/********************************************************************
 * Copyright (c) Certus Software, 2021.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import { Injectable } from '@angular/core';
import {catchError} from 'rxjs/operators';
import {environment} from 'src/environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';

@Injectable()
export class ApiService {
  constructor(
    private http: HttpClient
  ) { }

  private handleError(error: any) {
    if (error.error instanceof ErrorEvent) {
      /*console.error('Error occurred:', error.error.message);*/
    } else {
      /*console.error(
        `Returned code ${error.status}, ` +
        `Body: ${error.error}`
      );*/
    }
    return throwError (error);
  }

  get(path: string, params: Object = {}): Observable<any> {
    return this.http.get(`${environment.api_url}${path}`, params)
      .pipe(catchError(this.handleError));
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.http.put(`${environment.api_url}${path}`, body)
      .pipe(catchError(this.handleError));
  }

  post(path: string, body: Object = {}): Observable<any> {
    return this.http.post(`${environment.api_url}${path}`, body)
      .pipe(catchError(this.handleError));
  }

  postWithOptions(path: string, body: Object = {}, options: any = {}): Observable<any> {
    return this.http.post(`${environment.api_url}${path}`, body, options)
      .pipe(catchError(this.handleError));
  }

  delete(path): Observable<any> {
    return this.http.delete(`${environment.api_url}${path}`)
      .pipe(catchError(this.handleError));
  }

  getAppResource(path: string, params: Object = {}): Observable<any> {
    return this.http.get(`${environment.app_url}${path}`, params)
      .pipe(catchError(this.handleError));
  }
}
